// extracted by mini-css-extract-plugin
export default {"container":"containers_container__GX0IR"};